import { ADD_ANALYTICS, UPDATE_ANALYTICS } from "./types";

export const analyticsReducer = (state, action) => {
  switch (action.type) {
    case ADD_ANALYTICS:
      localStorage.setItem("phyllo_analytics", JSON.stringify(action.payload));
      return action.payload;
    case UPDATE_ANALYTICS:
      const currState = {
        ...state,
        ...action.payload,
      };
      localStorage.setItem("phyllo_analytics", JSON.stringify(currState));
      return currState;
    default:
      localStorage.setItem("phyllo_analytics", JSON.stringify(state));
      return state;
  }
};
